import { DonutChart } from '@/_shared/components/charts/donut.js';
import { useTsRest } from '@/_shared/context/ts-rest.js';
import { Card } from '../_shared/components/card/index.js';
import { Count } from '../_shared/components/count/index.js';
import { LoadingSkeleton } from '../_shared/components/loading-skeleton/index.js';
import { useStyles } from './_styles.js';

export function Dashboard() {
    const styles = useStyles();
    const tsr = useTsRest();

    const { data, isFetching } = tsr.dashboard.getDashboard.useQuery({
        queryKey: ['dashboard', 'getDashboard'],
        refetchInterval: 30_000,
    });

    return (
        <div className={styles.page}>
            {/* Row 1: Claims */}
            {/* Claims This Year by Type - Donut Chart */}
            <Card isFetching={isFetching} title="Schäden dieses Jahr" description="Nach Schadenart">
                {data === undefined ? (
                    <LoadingSkeleton />
                ) : (
                    <DonutChart data={data.body.claimsThisYearByType} label="Schäden" />
                )}
            </Card>

            {/* Claims Last Year by Type - Donut Chart */}
            <Card isFetching={isFetching} title="Schäden Vorjahr" description="Nach Schadenart">
                {data === undefined ? (
                    <LoadingSkeleton />
                ) : (
                    <DonutChart data={data.body.claimsLastYearByType} label="Schäden" />
                )}
            </Card>

            {/* Row 2: Documents */}
            {/* Documents This Year by Decision - Donut Chart */}
            <Card isFetching={isFetching} title="Zahlungsdokumente dieses Jahr" description="Nach Entscheidung">
                {data === undefined ? (
                    <LoadingSkeleton />
                ) : (
                    <DonutChart data={data.body.documentsThisYearByDecision} label="Dokumente" />
                )}
            </Card>

            {/* Documents Last Year by Decision - Donut Chart */}
            <Card isFetching={isFetching} title="Zahlungsdokumente Vorjahr" description="Nach Entscheidung">
                {data === undefined ? (
                    <LoadingSkeleton />
                ) : (
                    <DonutChart data={data.body.documentsLastYearByDecision} label="Dokumente" />
                )}
            </Card>

            {/* Row 3: Payouts */}
            {/* Payout This Year - Number */}
            <Card isFetching={isFetching} title="Schadenauszahlungen dieses Jahr" description="Gesamtsumme">
                {data === undefined ? <LoadingSkeleton /> : <Count count={data.body.payoutThisYear} format="euro" />}
            </Card>

            {/* Payout Last Year - Number */}
            <Card isFetching={isFetching} title="Schadenauszahlungen Vorjahr" description="Gesamtsumme">
                {data === undefined ? <LoadingSkeleton /> : <Count count={data.body.payoutLastYear} format="euro" />}
            </Card>
        </div>
    );
}
